<template>
  <aside class="shop-controls" :class="{ active: controlState.showMobileControls }">
    <div class="shop-controls-wrapper">
      <ais-configure :hitsPerPage="hitsPerPage" :attributesToSnippet="['product__description:12']" />

      <!-- ///// Search ///// -->
      <ais-search-box placeholder="Filter by keyword...">
        <debounced-search-box />
      </ais-search-box>

      <!-- ///// Hides Filter Options on Mobile ///// -->
      <button class="close-controls-top" :class="{ active: controlState.showMobileControls }" @click="controlState.showMobileControls = !controlState.showMobileControls"></button>
      <h4 class="heading">Filter Products:</h4>

      <!-- ///// Collections ///// -->
      <ais-panel v-if="showCollections">
        <template v-slot:header>Collections</template>
        <ais-menu-select attribute="product__collections__names" :transform-items="transformCollections">
          <template v-slot:default="{ items, canRefine, refine, createURL }">
            <div class="ais-MenuSelect-select filter-option-list">
              <figure v-for="item in items" :key="item.value" class="ais-MenuSelect-option filter-option-list-item">
                <a :class="{ active: item.isRefined }" @click.prevent="onCollectionClick(item, refine)">
                  {{ item.label }}
                </a>
              </figure>
            </div>
          </template>
        </ais-menu-select>
      </ais-panel>

      <!-- ///// Category ///// -->
      <ais-hierarchical-menu :attributes="hierarchicalAttributes" :sort-by="categorySorting" />

      <!-- Parent DIV to allow last-child selector -->
      <div class="ais-panels">
        <!-- ///// Cut ///// -->
        <ais-panel v-show="showApparelFacets">
          <template v-slot:header>Cut</template>
          <ais-menu-select attribute="sex_readable" :sort-by="sexSorting">
            <template v-slot:default="{ items, canRefine, refine, createURL }">
              <div class="ais-MenuSelect-select filter-option-list">
                <figure v-for="item in items" :key="item.value" class="ais-MenuSelect-option filter-option-list-item">
                  <a :class="{ active: item.isRefined }" @click.prevent="refine(item.isRefined ? '' : item.value)">
                    {{ item.label }}
                  </a>
                </figure>
              </div>
            </template>
          </ais-menu-select>
        </ais-panel>

        <!-- ///// Material ///// -->
        <ais-panel v-show="showApparelFacets">
          <template v-slot:header>Material</template>
          <ais-menu-select attribute="material_readable" :sort-by="menuSorting">
            <template v-slot:default="{ items, canRefine, refine, createURL }">
              <div class="ais-MenuSelect-select filter-option-list">
                <figure v-for="item in items" :key="item.value" class="ais-MenuSelect-option filter-option-list-item">
                  <a :class="{ active: item.isRefined }" @click.prevent="refine(item.isRefined ? '' : item.value)">
                    {{ item.label }}
                  </a>
                </figure>
              </div>
            </template>
          </ais-menu-select>
        </ais-panel>

        <!-- ///// Colors ///// -->
        <ais-panel v-show="showApparelFacets || showHatFacets || showPhoneCaseFacets || showDrinkwareFacets">
          <template v-slot:header>Color</template>
          <ais-menu-select attribute="icon_color_palettized" :sort-by="menuSorting" :limit="20">
            <template v-slot:default="{ items, canRefine, refine, createURL }">
              <div class="ais-MenuSelect-select filter-option-list colors">
                <figure v-for="item in items" :key="item.value" class="ais-MenuSelect-option filter-option-list-item" :class="readableColor(item.label)">
                  <a :class="{ active: item.isRefined }" @click.prevent="refine(item.isRefined ? '' : item.value)">
                    <span>{{ readableColor(item.label) }}</span>
                  </a>
                </figure>
              </div>
            </template>
          </ais-menu-select>
        </ais-panel>

        <!-- ///// Availability ///// -->
        <ais-panel>
          <template v-slot:header>Availability</template>
          <ais-menu-select attribute="product__sales_method" :sort-by="menuSorting">
            <template v-slot:default="{ items, canRefine, refine, createURL }">
              <div class="ais-MenuSelect-select filter-option-list">
                <figure v-for="item in items" :key="item.value" class="ais-MenuSelect-option filter-option-list-item">
                  <a :class="{ active: item.isRefined }" @click.prevent="refine(item.isRefined ? '' : item.value)">
                    {{ item.label }}
                  </a>
                </figure>
              </div>
            </template>
          </ais-menu-select>
        </ais-panel>

        <!-- ///// Buy it Now ///// -->
        <ais-panel v-if="showBuyItNow">
          <!--
                        <template v-slot:header>Buy It Now</template>
                        -->
          <ais-toggle-refinement attribute="available_for_sale" label="Buy It Now" class="">
            <template v-slot:default="{ value, canRefine, refine, createURL }">
              <label
                class="ais-ToggleRefinement-label"
                :class="{
                  'ais-ToggleRefinement-checkbox-active': value.isRefined,
                }"
              >
                <input class="ais-ToggleRefinement-checkbox" type="checkbox" :name="value.name" :value="true" :checked="value.isRefined" @change="refine(value)" />
                <span class="ais-ToggleRefinement-labelText">Buy It Now</span>
                <span v-if="value.count !== null" class="ais-ToggleRefinement-count">
                  {{ value.count.toLocaleString() }}
                </span>
              </label>
            </template>
          </ais-toggle-refinement>
        </ais-panel>
      </div>

      <!-- ///// Clear Filters Button ///// -->
      <ais-clear-refinements>
        <template v-slot:default="{ canRefine, refine, createURL }">
          <button type="reset" :class="['ais-ClearRefinements-button', !canRefine && `ais-ClearRefinements-button--disabled`]" :disabled="!canRefine" @click.prevent="refine">
            Clear All Filters
            <span class="x"></span>
          </button>
        </template>
      </ais-clear-refinements>

      <!-- ///// Hides Filter Options on Mobile ///// -->
      <button class="close-controls" :class="{ active: controlState.showMobileControls }" @click="controlState.showMobileControls = !controlState.showMobileControls">Done</button>
    </div>
  </aside>
</template>
<script>
import { defineAsyncComponent } from "vue";
const DebouncedSearchBox = defineAsyncComponent(() => import("./debounced-search-box.vue"));

export default {
  components: {
    DebouncedSearchBox,
  },

  mixins: [],

  inject: {
    controlState: "controlState",
    instantSearchInstance: {
      from: "$_ais_instantSearchInstance",
      default() {
        const tag = this.$options._componentTag;
        throw new TypeError(`It looks like you forgot to wrap your search component "<search-controls>" inside of an "<ais-instant-search>" component.`);
      },
    },
  },

  props: {
    hitsPerPage: {
      type: Number,
      required: true,
    },

    showBuyItNow: {
      type: Boolean,
      required: true,
    },

    showCollections: {
      type: Boolean,
      required: true,
    },

    showApparelFacets: {
      type: Boolean,
      required: true,
    },

    showHatFacets: {
      type: Boolean,
      required: true,
    },

    showPhoneCaseFacets: {
      type: Boolean,
      required: true,
    },

    showDrinkwareFacets: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      menuSorting: ["count:desc", "name:asc"],
      categorySorting: ["count:desc"],

      hierarchicalAttributes: ["categories__lvl0", "categories__lvl1"],
    };
  },

  computed: {},

  methods: {
    onCollectionClick(item, refine) {
      if (item.isRefined && this.instantSearchInstance.helper.state.index === "variants:product__random:asc") {
        this.instantSearchInstance.helper.state.index = "variants:product__week_sold:desc";
      }

      refine(item.isRefined ? "" : item.value);
    },

    sexSorting(a, b) {
      const order = ["Men", "Women", "Unisex", "Infant", "Toddler", "Youth"];

      const aIndex = order.indexOf(a.name);
      const bIndex = order.indexOf(b.name);

      if (aIndex < 0 && bIndex >= 0) {
        return 1;
      }

      if (aIndex >= 0 && bIndex < 0) {
        return -1;
      }

      if (aIndex < 0 && bIndex < 0) {
        try {
          return a.name.localeCompare(b.name);
        } catch (e) {
          debugger;
        }
      }

      if (aIndex >= 0 && bIndex >= 0) {
        if (aIndex < bIndex) {
          return -1;
        } else if (aIndex > bIndex) {
          return 1;
        } else if (aIndex === bIndex) {
          return 0;
        }
      }

      return 0;
    },

    readableColor(color) {
      let name = color;

      switch (color) {
        case "#545454":
          name = "Charcoal";
          break;
        case "#000":
          name = "Black";
          break;
        case "#fff":
          name = "White";
          break;
        case "#a9a9a9":
          name = "Silver";
          break;
        case "#0054ff":
          name = "Blue";
          break;
        case "#f00":
          name = "Red";
          break;
        case "#00a9ff":
          name = "Aqua";
          break;
        case "#fe0":
          name = "Yellow";
          break;
        case "#2aff00":
          name = "Green";
          break;
        case "#7f00ff":
          name = "Purple";
          break;
        case "#f60":
          name = "Orange";
          break;
        case "#ff007f":
          name = "Fuschia";
          break;
      }

      return name;
    },

    transformCollections(collections) {
      return collections.map((collection) => {
        switch (collection.label) {
          case "Tis the Season":
            collection.label = "’Tis the Season";
        }

        return collection;
      });
    },
  },
};
</script>
